import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const SubcategoryCardGrid = t0 => {
  const $ = _c(6);
  const {
    children,
    desktopColumnCount: t1
  } = t0;
  const desktopColumnCount = t1 === undefined ? "2" : t1;
  const t2 = desktopColumnCount === "2";
  const t3 = desktopColumnCount === "3";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("grid auto-rows-[1fr] gap-2 lg:grid-cols-[1fr_1fr]", {
      "lg:grid-cols-[1fr_1fr]": t2,
      "lg:grid-cols-[1fr_1fr_1fr]": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className={t4}>{children}</div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
SubcategoryCardGrid.propTypes = {
  children: PropTypes.node,
  desktopColumnCount: PropTypes.oneOf(['2', '3'])
};
export default SubcategoryCardGrid;